<template>
    <div>
        <v-row>
            <v-col cols="8">
                <v-text-field
                    v-model="$store.state.cp.searchString"
                    label="Søg"
                    clearable
                    solo
                    prepend-inner-icon="fa-search"
                    hide-details
                />
            </v-col>
            <v-col cols="4">
                <v-card>
                    <v-tabs grow v-model="$store.state.cp.department">
                        <v-tab>Tryg</v-tab>
                        <v-tab>Alka</v-tab>
                    </v-tabs>
                </v-card>
            </v-col>
        </v-row>
        <loader v-if="loading" />
        <v-row v-else>
            <v-col cols="12">
                <v-card>
                    <v-card-title class="justify-end">
                        <v-btn color="primary" class="white--text" @click="distributeCampaigns">
                            <v-icon left>fa-random</v-icon>
                            fordel kampagner
                        </v-btn>
                    </v-card-title>
                    <v-list class="striped-list">
                        <v-list-item dense inactive v-for="(campaign, index) in paginatedCampaigns" :key="index">
                            <v-list-item-content>
                                <v-col cols="4" class="d-flex justify-start align-center">
                                    <div :title="campaign.name" v-line-clamp:35="1">{{ campaign.name }}</div>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="editCampaign(campaign)" tile>
                                        <v-icon left>
                                            fa-edit
                                        </v-icon>
                                        Rediger
                                    </v-btn>
                                </v-col>
                                <v-col cols="5" class="d-flex justify-end align-center">
                                    <v-btn
                                        class="mx-1"
                                        :color="(level => {if (!levels.includes(level)) return 'primary'})(campaign.level)"
                                        @click="campaign.level = -1; updateCampaignSetting(campaign)"
                                    >
                                        X
                                    </v-btn>
                                    <v-btn
                                        v-for="(btnLevel, index) in levels"
                                        :key="'b' + index"
                                        class="mx-1"
                                        :color="activeButton(campaign.level, btnLevel)"
                                        @click="campaign.level = btnLevel; updateCampaignSetting(campaign)"
                                    >
                                        <span v-if="btnLevel === 0">OB</span>
                                        <span v-else>{{ btnLevel }}</span>
                                    </v-btn>
                                </v-col>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-row v-if="filteredCampaigns.length > itemsPerPage">
                        <v-col>
                            <v-pagination
                                v-model="page"
                                :length="Math.ceil(filteredCampaigns.length / itemsPerPage)"
                                :total-visible="10"
                            />
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-dialog width="700" v-model="editingCampaign" persistent>
                <v-card>
                    <v-card-title>
                        {{ dialogCampaign.name }}
                    </v-card-title>
                    <v-divider />
                    <v-card-text>
                        <v-checkbox hide-details v-model="dialogCampaign.excludeCount" label="Eksluder afsluttede i kval." />
                        <v-checkbox hide-details v-model="dialogCampaign.partner" label="Partner-kampagne" />
                        <v-checkbox hide-details v-model="dialogCampaign.retention" label="Retention-kampagne" />
                        <br />
                        <v-text-field
                            outlined
                            type="number"
                            suffix="minutter"
                            v-model="dialogCampaign.serviceLevel"
                            label="Service level"
                            class="text-center" />
                        <v-textarea v-model="dialogCampaign.description" auto-grow outlined label="Beskrivelse" />
                        <v-textarea v-model="dialogCampaign.pitch" auto-grow outlined label="Pitch" />
                    </v-card-text>
                    <v-divider />
                    <v-card-actions class="justify-end">
                        <v-btn text color="red" @click="editingCampaign = false">Annuller</v-btn>
                        <v-btn text color="green" @click="updateCampaignSetting(dialogCampaign); editingCampaign = false">Gem</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
            page: 1,
            itemsPerPage: 7,
            levelTab: 0,
            loading: true,
            campaigns: null,
            editingCampaign: false,
            dialogCampaign: {}
        }
    },
    computed: {
        filteredCampaigns () {
            return [...this.campaigns].sort((a, b) => {
                if (!this.levels.includes(b.level)) return -1
                return a.level > b.level ? -1 : 1
            })
            .filter(item => {
                return this.$store.state.cp.searchString
                ? item.name.replace(/[_\s]/gi, '').toLowerCase().includes(this.$store.state.cp.searchString.replace(/[_\s]/gi, '').toLowerCase())
                : true
            })
        },
        paginatedCampaigns () {
            return [...this.filteredCampaigns].splice(this.itemsPerPage * (this.page - 1), this.itemsPerPage)
        },
        levels() {
            return this.$store.state.cp.levels[this.department]
        },
		department() {
			return this.$store.getters['cp/department']
        },
        departments() {
            return this.$store.state.cp.departments
        }
	},
    methods: {
        async distributeCampaigns () {
            this.$http().post('/controlpanel/campaigns/setCampaigns')
        },
        editCampaign (campaign) {
            this.editingCampaign = true
            this.dialogCampaign = campaign
        },
        async updateCampaignSetting (campaign) {
			await this.$http().patch('/controlpanel/campaigns/campaignSetting', {
                ...campaign,
                id: campaign.settingsId
            })
        },
        async getData() {
            this.loading = true
            let response = await this.$http().get('/controlpanel/campaigns', {
                params: {
                    department: this.department
                }
            })
            this.campaigns = response.data
            this.loading = false
        },
        activeButton(level, btnLevel) {
            if (level === btnLevel) return 'primary'
        }
    },
    watch: {
        department: function () {
            this.getData()
        }
    },
    async created () {
        await this.getData()
    }
}
</script>